// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"generic_page-layout__xvmcs","video-spin":"generic_video-spin__CR2l7"};